import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Formula1 = () => {
  return (
    <SportsLayoutComp name={'Formula 1'}/>
  )
}

export default Formula1